var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPakistan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 26,
    viewBox: "0 0 36 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_19_11275)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_19_11275",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 3,
    width: 30,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 3,
    width: 30,
    height: 20,
    rx: 2,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_19_11275)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.2819 3H1V23H35.2819V3Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.2819 3H9.5705V23H35.2819V3Z",
    fill: "#2E6934"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.8838 6.99732C25.1915 6.99732 27.8698 9.68229 27.8698 12.9967C27.8698 16.311 25.1915 18.996 21.8838 18.996C18.5762 18.996 15.8979 16.311 15.8979 12.9967C15.8979 9.68229 18.5829 6.99732 21.8838 6.99732Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.768 7.51959C22.0311 5.50418 25.5062 5.70506 27.5149 7.97489C29.5303 10.2447 29.3227 13.7198 27.0596 15.7419C24.7965 17.7573 21.3214 17.5564 19.3127 15.2866C17.2973 13.0167 17.5049 9.54168 19.768 7.51959Z",
    fill: "#2E6934"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.3633 9.01272L24.5353 9.80951L24.9304 10.7268L26.3633 9.01272Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.3632 9.01272L25.3522 10.7335L24.4951 10.2313L26.3632 9.01272Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.5909 11.3495L25.2651 9.85638L24.5219 10.5192L26.5909 11.3495Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.5909 11.3495L24.6425 10.921L24.8567 9.94342L26.5909 11.3495Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.0733 8.50385L24.2675 10.4992L25.2584 10.3987L24.0733 8.50385Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.0733 8.50385L25.399 10.0037L24.6491 10.6666L24.0733 8.50385Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.4416 12.2936L25.4526 10.5661L24.5889 10.0639L24.4416 12.2936Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.4416 12.2936L24.2474 10.305L25.2384 10.2046L24.4416 12.2936Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.8815 10.5326L24.8299 10.9612L25.0442 9.99029L22.8815 10.5326Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.8815 10.5326L24.7094 9.73586L25.1111 10.6532L22.8815 10.5326Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_19_11275",
    x: 0,
    y: 0,
    width: 36,
    height: 26,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.18 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_19_11275"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_19_11275",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPakistan);
export default __webpack_public_path__ + "static/media/Pakistan.f9062905e5979f3d12cdacdd1792e834.svg";
export { ForwardRef as ReactComponent };